module.exports = __webpack_public_path__ + "static/fonts/DINProBold.6d5317bb.ttf";